// extracted by mini-css-extract-plugin
export default {"container":"xj-z","blurb":"yj-z","links":"zj-z"};